/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoAnalyticsModelsUserWidget
 */
export interface MelcoAnalyticsModelsUserWidget {
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsUserWidget
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsUserWidget
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsUserWidget
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsUserWidget
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsUserWidget
     */
    url?: string | null;
}

export function MelcoAnalyticsModelsUserWidgetFromJSON(json: any): MelcoAnalyticsModelsUserWidget {
    return MelcoAnalyticsModelsUserWidgetFromJSONTyped(json, false);
}

export function MelcoAnalyticsModelsUserWidgetFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoAnalyticsModelsUserWidget {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function MelcoAnalyticsModelsUserWidgetToJSON(value?: MelcoAnalyticsModelsUserWidget | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'type': value.type,
        'url': value.url,
    };
}


